export enum PaymentTerm {
    _10d = 1,
    _15d30d45d = 2,
    _15d = 3,
    // _20d30d = 4,
    _20d = 5,
    _30d60d90d = 6,
    _30d = 7,
    // _40d = 8,
    _60d = 9,
    _90d = 10,
    _aVista30d60 = 11
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/PaymentTerm.ts